// extracted by mini-css-extract-plugin
export default {"titles":"Error_titles__mTjXx","Efeito":"Error_Efeito__IeiYZ"};